import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService } from '../../../../../core';
import { CampanhaCliente, CampanhaClienteFormComponent } from '../clientes';
import { CampanhaItemFormComponent } from '../itens';
import { isTipoPromocaoSemPromocao, isTipoPromocaoCliente, isTipoPromocaoItem } from '../../../promocao/tipo';

interface Config {
    isSemPromocao: boolean;
    isPromocaoCliente: boolean;
    isPromocaoItem: boolean;
}

@Component({
    selector: 'sgt-campanha-promocao-form',
    templateUrl: './campanha-promocao-form.component.html',
    styleUrls: ['./campanha-promocao-form.component.less']
})
export class CampanhaPromocaoFormComponent implements OnInit, OnChanges {
    config: Config;
    @Input() tipoPromocao: number;
    @Output() tipoPromocaoChange = new EventEmitter<number>();
    @Input() clientes: CampanhaCliente[];

    @Input() canEdit = true;
    @Input() canEditTipoPromocao = true;

    @ViewChild('form') form: NgForm;
    @ViewChild('clientesForm') clientesForm: CampanhaClienteFormComponent;
    @ViewChild('itensForm') itensForm: CampanhaItemFormComponent;

    constructor(private messageService: MessageService) { }

    ngOnInit(): void {
        this.setConfig();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (!changes[propName].isFirstChange() ) {
                if (propName === 'tipoPromocao') {
                    this.setConfig();
                }
            }
        }
    }

    private setConfig() {
        this.config = {
            isSemPromocao: isTipoPromocaoSemPromocao(this.tipoPromocao),
            isPromocaoCliente: isTipoPromocaoCliente(this.tipoPromocao),
            isPromocaoItem: isTipoPromocaoItem(this.tipoPromocao)
        };
    }


    /** Verifica se o tipo de promoção da campanha é Sem Promoção */
    isTipoSemPromocao(): boolean {
        return this.config.isSemPromocao;
    }

    /** Verifica se o tipo de promoção da campanha é Cliente */
    isTipoCliente(): boolean {
        return this.config.isPromocaoCliente;
    }

    /** Verifica se o tipo de promoção da campanha é Item */
    isTipoItem(): boolean {
        return this.config.isPromocaoItem
    }

    /** Ao alterar o tipo de promoção */
    onChangeTipoPromocao(tipoPromocao: number) {
        this.tipoPromocao = tipoPromocao;
        this.tipoPromocaoChange.emit(this.tipoPromocao);
        // this.setConfig();
    }

    /** Insere um novo cliente na promoção */
    insertCliente(idCliente: number = null) {
        // Somente se a promoção for de cliente
        if (!this.isTipoCliente()) {
            return;
        }
        this.clientesForm?.insert(idCliente);
    }

    /** Verifica se a promoção da campanha está válida */
    isValid(): boolean {
        if (!this.canEdit) {
            return true;
        }

        // Clientes
        if (this.isTipoCliente()) {
            if (!this.clientes || this.clientes.length === 0) {
                this.messageService.warning(`Promoção de clientes selecionada na campanha e nenhum cliente adicionado. Adicione pelo menos um cliente à esta campanha ${this.canEditTipoPromocao ? 'ou altere o tipo da promoção' : ''}`, 'Atenção')
                this.clientesForm?.insert();
                return false;
            }

            if (!this.clientesForm?.isValid()) {
                return false;
            }
        }

        // Itens
        if (this.isTipoItem()) {
            if (!this.itensForm?.isValid()) {
                return false;
            }
        }

        // Form válido
        if (this.form.invalid) {
            this.messageService.warning('Informe corretamente todos os campos da promoção desta campanha', 'Atenção');
            return false;
        }

        return true;
    }

    /** Resolve a promoção da campanha */
    resolve() {
        // Clientes
        if (this.isTipoCliente()) {
            this.clientesForm?.resolve();
        }

        // Itens
        if (this.isTipoItem()) {
            this.itensForm?.resolve();
        }
    }
}
